import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class CustomerID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
